import { useSelector } from 'react-redux';
import { ThemeProvider, CssBaseline, StyledEngineProvider, GlobalStyles } from '@mui/material';
import ThemeRoutes from 'routes';
import themes from 'themes';
import NavigationScroll from 'layout/NavigationScroll';
import './assets/scss/browserview.css';
import './assets/scss/mobileview.css';
import './assets/scss/font.scss';
import { useEffect } from 'react';
import './index.css';
const App = () => {
    // this code was written to fix mircosoft edge default scroll behaviour
    useEffect(() => {
        document.body.style.overscrollBehavior = 'none';
        return () => {
            document.body.style.overscrollBehavior = '';
        };
    }, []);
    const customization = useSelector((state) => state.customization);
    return (
        <StyledEngineProvider injectFirst>
            <ThemeProvider theme={themes(customization)}>
                <CssBaseline />
                <GlobalStyles
                    styles={{
                        'input:-webkit-autofill': {
                            animationName: 'none !important'
                        },
                        html: {
                            WebkitTextSizeAdjust: '100%',
                            msTextSizeAdjust: '100%'
                        },
                        '@media print': {
                            '.MuiButtonBase-root': {
                                WebkitPrintColorAdjust: 'exact',
                                printColorAdjust: 'exact'
                            }
                        }
                    }}
                />
                <NavigationScroll>
                    <ThemeRoutes />
                </NavigationScroll>
            </ThemeProvider>
        </StyledEngineProvider>
    );
};

export default App;
// import { useSelector } from 'react-redux';
// import { ThemeProvider } from '@mui/material/styles';
// import { CssBaseline, StyledEngineProvider } from '@mui/material';
// import ThemeRoutes from 'routes';
// import themes from 'themes';
// import NavigationScroll from 'layout/NavigationScroll';
// import './assets/scss/browserview.css';
// import './assets/scss/mobileview.css';
// // ==============================|| APP ||============================== //

// const App = () => {
//     const customization = useSelector((state) => state.customization);
//     return (
//         <>
//             <StyledEngineProvider injectFirst>
//                 <ThemeProvider theme={themes(customization)}>
//                     <CssBaseline />
//                     <NavigationScroll>
//                         <ThemeRoutes />
//                     </NavigationScroll>
//                 </ThemeProvider>
//             </StyledEngineProvider>
//         </>
//     );
// };

// export default App;
